<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['order.no']" :placeholder="$t('placeholder.returnOrderNo')" allowClear @pressEnter="getData" @search="getData" />
      <a-input-search v-model="query['customer.name']" :placeholder="$t('placeholder.supplierName')" allowClear @pressEnter="getData" @search="getData" />
      <a-select v-model="query['storer.id']" :placeholder="$t('placeholder.storer')" allowClear class="query">
        <a-select-option v-for="d in storerData" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <a-input-search v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear @pressEnter="getData" @search="getData" />
      <a-input-search v-model="query['item.name']" :placeholder="$t('placeholder.itemName')" allowClear @pressEnter="getData" @search="getData" />
      <a-input-search v-model="query['item.barcodes']" :placeholder="$t('placeholder.itemBarcode')" allowClear @pressEnter="getData" @search="getData" />
      <a-date-picker v-model="query.checkingTimeFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" allowClear show-today valueFormat="YYYY-MM-DD" />
      <a-date-picker v-model="query.checkingTimeFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" allowClear show-today valueFormat="YYYY-MM-DD" />
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="getData"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exportExcel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      size="mini"
      :height="scrollY"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" sortable title="business.label.returnOrderNo" width="120" />
      <vxe-column field="orderType.name" title="business.label.orderType" width="120" />
      <vxe-column field="detail.checkingTime" sortable title="business.label.inspectTime" width="170"/>
      <vxe-column field="order.orderStatus" sortable title="business.label.orderStatus" width="100">
        <span slot-scope="{ row }">{{ orderStatusData.find(item => item.ordinal === row.order.orderStatus).name }}</span>
      </vxe-column>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="supplier.name" title="business.label.supplierName" width="150" />
      <vxe-column field="item.no" title="business.label.itemNo" width="80" />
      <vxe-column field="item.name" title="business.label.itemName" width="150" />
      <vxe-column field="pack.specification" title="business.label.specification" width="150" />
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="dosageForm.name" title="business.label.dosageForm" width="120" />
      <vxe-column field="item.permitHolder" title="business.label.permitHolder" width="150" />
      <vxe-column field="lot.no" sortable title="business.label.lotNo" width="150" />
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100" />
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100" />
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150" />
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150" />
      <vxe-column field="lot.producingArea" title="business.label.producingArea" width="150" />
      <vxe-column field="asnOrder.operator" title="business.label.maker" width="120" />
      <vxe-column field="detail.inspector" title="business.label.inspector" width="120" />
      <vxe-column field="detail.acceptedQuantity" title="business.label.acceptedQuantity" width="180" />
      <vxe-column field="detail.rejectedQuantityOfAcceptance" sortable title="business.label.rejectedQuantityOfAcceptance" width="200" />
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'SaleReturnDetailQuery',
    data() {
      return {
        data: [],
        orderStatusData: [],
        storerData: [],
        loading: false,
        page: 1,
        size: 20,
        contentSize: 0,
        query: {
          'no': '',
          'customer.name': '',
          'storer.id': undefined,
          checkingTimeFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.barcodes': '',
          'lot.no': '',
          'refundable': true
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815)// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    mounted() {
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatusData = res.result
        }
      })
    },
    methods: {
      moment,
      disabledStartDate(startValue) {
        const endValue = this.query.checkingTimeFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.query.checkingTimeFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        const args = Object.assign({}, this.query)
        if (args.checkingTimeFilter.start === null && args.checkingTimeFilter.end === null) {
          args.checkingTimeFilter = null
        }
        findAll('receiptDetailFactory', args, this.page, this.size).then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
            setTimeout(() => {
              this.loading = false
            }, 300)
          } else {
            this.loading = false
          }
        })
      },
      exportExcel() {
        this.$refs.table.openExport()
      },
      reset() {
        this.query = {
          'no': '',
          'customer.name': '',
          'storer.id': undefined,
          checkingTimeFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.barcodes': '',
          'lot.no': '',
          'refundable': true
        }
        this.getData()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 180px;
  }
</style>